import {
  PROFILE_CONSTANT_REQUEST,
  PROFILE_CONSTANT_SUCCESS,
  PROFILE_CONSTANT_FAIL,
} from "../constants/constants";
export const listProfileImageReducer = (
  state = { ListedImage: "" },
  action
) => {
  switch (action.type) {
    case PROFILE_CONSTANT_REQUEST:
      return { loading: true, ListedImage: "" };

    case PROFILE_CONSTANT_SUCCESS:
      return {
        loading: false,
        ListedImage: action.payload,
      };

    case PROFILE_CONSTANT_FAIL:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
};
